import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../styles/QuickContactForm.css";

export default function QuickContactForm() {
  const { t } = useTranslation("quickContact");
  const [form, setForm] = useState({ nome: "", telemovel: "", email: "" });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState(null);

  const validate = () => {
    const e = {};
    if (!form.nome.trim()) e.nome = t("errName");
    if (!form.telemovel.trim() && !form.email.trim()) e.contact = t("errContact");
    if (form.email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
      e.email = t("errEmail");
    return e;
  };

  const handleChange = (field) => (ev) => {
    setForm((f) => ({ ...f, [field]: ev.target.value }));
    setErrors((e) => { const n = { ...e }; delete n[field]; delete n.contact; return n; });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setStatus("sending");
    try {
      const res = await fetch("/send-quick.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      setStatus(res.ok ? "success" : "error");
    } catch {
      setStatus("error");
    }
  };

  if (status === "success") {
    return (
      <div className="qcf">
        <div className="qcf__success">
          <span className="qcf__success-icon">✓</span>
          <p>{t("success")}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="qcf">
      <div className="qcf__header">
        <span className="qcf__eyebrow">{t("eyebrow")}</span>
        <h2 className="qcf__title">{t("title")}</h2>
        <p className="qcf__subtitle">{t("subtitle")}</p>
      </div>

      <form className="qcf__form" onSubmit={handleSubmit} noValidate>

        <div className={`qcf__field ${errors.nome ? "qcf__field--error" : ""}`}>
          <label>
            {t("name")} <span className="qcf__required">*</span>
          </label>
          <input
            type="text"
            placeholder={t("namePlaceholder")}
            value={form.nome}
            onChange={handleChange("nome")}
            autoComplete="name"
          />
          {errors.nome && <span className="qcf__error">{errors.nome}</span>}
        </div>

        <div className={`qcf__field ${errors.contact ? "qcf__field--error" : ""}`}>
          <label>
            {t("phone")}
            <span className="qcf__hint"> — {t("orLabel")}</span>
          </label>
          <input
            type="tel"
            placeholder="+351 9XX XXX XXX"
            value={form.telemovel}
            onChange={handleChange("telemovel")}
            autoComplete="tel"
          />
        </div>

        <div className={`qcf__field ${errors.email || errors.contact ? "qcf__field--error" : ""}`}>
          <label>{t("email")}</label>
          <input
            type="email"
            placeholder={t("emailPlaceholder")}
            value={form.email}
            onChange={handleChange("email")}
            autoComplete="email"
          />
          {errors.email && <span className="qcf__error">{errors.email}</span>}
        </div>

        {errors.contact && (
          <span className="qcf__error qcf__error--contact">{errors.contact}</span>
        )}

        {status === "error" && (
          <p className="qcf__server-error">{t("error")}</p>
        )}

        <button type="submit" className="qcf__submit" disabled={status === "sending"}>
          <span>{status === "sending" ? t("sending") : t("submit")}</span>
        </button>
      </form>
    </div>
  );
}
